import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nav_bar = _resolveComponent("nav-bar")!
  const _component_the_navigation = _resolveComponent("the-navigation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_nav_bar, { msg: "Welcome to Your Vue.js + TypeScript App" }),
    _createVNode(_component_the_navigation, { onSetPage: _ctx.setActivePage }, null, 8, ["onSetPage"]),
    _createElementVNode("main", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activePage)))
    ])
  ], 64))
}